'use client'

import { FourColumnBenefits } from 'components/FourColumnBenefits'
import { PersonalSleepConnected } from 'components/Phantom/_sections/PersonalSleep'
import { BenefitProps } from 'components/Phantom/_sections/PersonalSleep/types'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'
import { getCoolingReviews, ReviewHighlights } from 'components/ReviewHighlights'
import { StickyConnected } from 'components/WebEv/CoverLP2023/Sticky'
import { MiniShopConnected } from 'pageCores/prospectingBJulia/localComponents'
import { FC } from 'react'
import { Hero } from './BedCoolingSystem/Hero/Hero'

const PERSONAL_SLEEP_BENEFITS: BenefitProps[] = [
	{
		title: 'The perfect temperature all night',
		description: "Autopilot cools and warms your bed to match your body's natural circadian rhythm, keeping you in deep and REM sleep for longer",
		icon: 'TemperatureLight',
	},
	{
		title: 'The ideal elevation for optimal sleep',
		description: 'Pod 4 Ultra makes micro-adjustments to your elevation while you sleep, improving your breathing, reducing pressure, and maximizing overall comfort',
		icon: 'ElevationLight',
	},
]

export const BedCoolingLP: FC<{ metricRegion: boolean }> = ({ metricRegion }) => {
	return (
		<>
			<StickyConnected scrollThreshold={typeof window !== 'undefined' ? window.innerHeight * 0.5 : 0} />
			<Hero
				headline="The #1 bed cooling system"
				subheadline="The most intelligent temperature controlled sleep technology"
				bullets={['Fits on any bed', `Cools down to ${metricRegion ? '12°C' : '55°F'}`, 'Dual zone temperature control']}
				videoSrc="https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/t_video-gif/v1742435315/prospecting_c_cover_drop-edit3_tl8il4.mp4"
				videoClassName="hacky_video"
				className="hacky_container"
				metricRegion={metricRegion}
			/>
			<FourColumnBenefits header={'Why the Pod?'} />
			<PersonalSleepConnected
				benefits={PERSONAL_SLEEP_BENEFITS}
				showExtraSleep={true}
				eyebrow={''}
				header={"Temperature regulation that's tailored to you"}
				subHeader={'The Pod personalizes your temperature on each side of the bed to create the ultimate sleeping environment for deeper and higher quality sleep'}
				cta={{
					href: '/product/pod-cover',
					text: 'Shop now',
				}}
				theme={'light'}
				headline="Cooling that makes a difference"
				graphTitle="The Pod gives you up to one more hour of sleep every night"
			/>
			<ReviewHighlights
				heading="The best bed cooling system, fueling extraordinary people like you"
				reviews={getCoolingReviews()}
			/>
			<MiniShopConnected
				addAsterisk
				pod4UltraDescription="The Pod 4 Ultra regulates your temperature with zones for two people, and can fit any mattress and bed frame. The Ultra mitigates snoring through automated elevation, and allows for custom positioning for reading and relaxing."
			/>
			<ScrollSequenceStatic />
		</>
	)
}
